import { BackButton } from '@/components/stashstr/BackButton';
import { Feed } from '@/components/stashstr/Feed';

export default function New() {
  return (
    <div>
      <BackButton />
      <h1 className="text-[18px] font-bold text-gray-900 dark:text-gray-100 mb-3">new</h1>
      <Feed sort="new" />
    </div>
  );
}
